import { Button, Form, Input, Modal, Select, Space, Table } from 'antd';
import { ParcelStatusContext } from '../../context/ParcelStatusProvider';
import { useContext, useEffect, useState } from 'react';
import { ColumnsType } from 'antd/es/table';
import { NetworkResult } from '../../common/CommonResult';
import { API } from '../../api';
import { useCallback } from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

interface CustomerScanStatusProps {
  visible: boolean;
  onClose: () => void;
  customer: number | null;
}
export const CustomerScanStatus = ({ visible, onClose, customer }: CustomerScanStatusProps) => {
  const { statusList } = useContext(ParcelStatusContext);
  const [data, setData] = useState<NetworkResult<any>>({ loading: true, result: [], error: false });
  const [form] = Form.useForm();
  useEffect(() => {
    if (customer && visible) {
      fetchScanStatus();
    }
  }, [customer, visible]);
  const fetchScanStatus = useCallback(async () => {
    try {
      setData({ loading: true, result: [], error: false });
      const { result } = await API.get({ apiVersion: 'api' })(`/customer/scan-status/${customer}`);
      console.log(result);
      const scanStatus = result.map((item: any) => {
        return {
          no: item.no,
          cd: item.cd,
          parcelStatus: item.parcelStatus.no,
          description: item.description,
          descriptionEn: item.descriptionEn,
        };
      });
      form.setFieldsValue({ customerNo: customer });
      form.setFieldsValue({ scanStatus: scanStatus });
      setData({ loading: false, result, error: false });
    } catch (error: any) {
      setData({ loading: false, result: [], error: true });
    }
  }, [customer]);
  const columns: ColumnsType<any> = [
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text: string, record: any) => {
        return <span>{text}</span>;
      },
    },
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count',
      render: (text: string, record: any) => {
        return <span>{text}</span>;
      },
    },
  ];
  const onSubmit = (values: any) => {
    console.log(values);
    API.post({ apiVersion: 'api' })(`/customer/scan-status/save`, values).then(() => {
      onClose();
    });
  };
  return (
    <Modal width={800} title="Scan Status" open={visible} onCancel={onClose} onOk={form.submit}>
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item name="customerNo" hidden>
          <Input type="hidden" />
        </Form.Item>
        <Form.List name="scanStatus">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item {...restField} name={[name, 'no']}>
                    <Input type="hidden" placeholder="Cd" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'cd']}
                    rules={[{ required: true, message: 'Missing cd' }]}
                  >
                    <Input placeholder="Cd" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'parcelStatus']}
                    rules={[{ required: true, message: 'Missing name' }]}
                  >
                    <Select style={{ width: '150px' }} placeholder="Select parcel status">
                      {statusList.map((item: any) => (
                        <Select.Option key={item.no} value={item.no}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'description']}
                    rules={[{ required: false, message: 'Missing description' }]}
                  >
                    <Input placeholder="Description" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'descriptionEn']}
                    rules={[{ required: true, message: 'Missing descriptionEn' }]}
                  >
                    <Input placeholder="Description EN" />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  Төлөв нэмэх
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};
